if (!customElements.get('wls-collection')) {
  class WLSCollection extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        loading: 'loading',
        hidden: 'hidden',
        empty: 'empty',
        contentWrapper: 'js-content-wrapper',
        filterCheckbox: 'js-filter-checkbox',
        dataStrength: '[data-strength]',
        filtersNavigationWarpper: 'js-filters-navigation-wrapper',
        collectionBlock: 'js-collection-block',
        collectionBlockProductList: 'js-collection-block-product-list',
        collectionProduct: 'js-collection-product',
        productDataCollectionsIDs: '[data-collection-ids]',
        collectionDataCollectionID: '[data-collection-id]',
        contentSections: 'js-content-sections',
        contentWrapperCollectionList: 'js-content-wrapper-product-list',
        selectPlaceholder: 'js-select-placeholder',
        dataCollectionSections: 'data-collection-sections',
        WLSCollectionSection: 'wls-collection-section',
        promoCard: 'wls-promo-card',
        clearFilters: 'js-btn-clear-filters',
        filtersNavigationItemsCounter: 'js-filters-navigtaion-items-counter',
        sectionCollectionFallbackMessage: 'js-wls-collection-section-fallback-message',
        productListWrapper: 'js-product-list-wrapper',
        doulbeRangeInputSelector: 'wls-double-range-input',
        fromSlider: 'js-from-slider',
        toSlider: 'js-to-slider',
        fromPlaceholder: 'js-from-placeholder',
        toPlaceholder: 'js-to-placeholder',
      };

      this.selectors = this.getSelectors();

      this.isLoadingCollection = false;
      this.isLoadingSingleCollection = false;
      this.updateURLTimeout = null;
      this.rangeDebounceTimeout = null; // Add debounce timeout for range inputs

      this.activeFilters = {
        sort_by: null,
        filter: {},
      };

      this.sortByFilter = 'sort_by';
      this.filter = 'filter';
      this.pageFilter = 'page';
      this.filterStrength = 'filter.p.m.wls.product_strengths';
      this.filterPrice = 'filter.v.price';
      this.filterPriceGte = '';
      this.filterPriceLte = '';
      this.customSortByValues = ['strength-ascending', 'strength-descending'];
      this.tempRangeFilters = {}; // Temporary storage for range filters
    }

    getSelectors() {
      return {
        contentWrapper: this.querySelector(`.${this.classes.contentWrapper}`),
        filtersNavigationWarpper: this.querySelector(`.${this.classes.filtersNavigationWarpper}`),
        filterCheckboxes: this.querySelectorAll(`.${this.classes.filterCheckbox}`),
        collectionBlocks: this.querySelectorAll(`.${this.classes.collectionBlock}`),
        collectionProducts: this.querySelectorAll(`.${this.classes.collectionProduct}`),
        filtersNavWrapper: this.querySelector(`.${this.classes.filtersNavWrapper}`),
        contentSections: this.querySelector(`.${this.classes.contentSections}`),
        contentWrapperCollectionList: this.querySelector(`.${this.classes.contentWrapperCollectionList}`),
        selectPlaceholder: this.querySelector(`.${this.classes.selectPlaceholder}`),
        WLSCollectionSections: this.querySelectorAll(`${this.classes.WLSCollectionSection}`),
        clearButton: this.querySelector(`.${this.classes.clearFilters}`),
        filtersNavigationItemsCounter: this.querySelector(`.${this.classes.filtersNavigationItemsCounter}`),
        doulbeRangeInputSelectors: this.querySelectorAll(`${this.classes.doulbeRangeInputSelector}`),
      };
    }

    /**
     * Lifecycle method called when the element is added to the DOM.
     * It sets up event listeners for each tag to handle tag selection.
     * @returns {void}
     */
    connectedCallback() {
      this.bindEvents();
      this.updateFromUrlParams();
    }

    /**
     * Bind event listeners to filter elements.
     */
    bindEvents() {
      this.setLoadingState();
      document.addEventListener('clear-filters-not-in-url', this.clearFiltersNotInUrl.bind(this));
      this.selectors.filterCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', (e) => this.handleFilterChange(e));
      });
      this.selectors.clearButton?.addEventListener('click', this.clearFilters.bind(this));
      this.selectors.doulbeRangeInputSelectors.forEach((rangeInput) => {
        if (rangeInput.dataset.filterBy === this.filterPrice) {
          const fromSlider = rangeInput.querySelector(`.${this.classes.fromSlider}`);
          const toSlider = rangeInput.querySelector(`.${this.classes.toSlider}`);
          this.filterPriceGte = fromSlider.dataset.filterBy;
          this.filterPriceLte = toSlider.dataset.filterBy;
          fromSlider.addEventListener('change', () =>
            this.handlePriceRangeDoubleInput(rangeInput, fromSlider, toSlider)
          );
          toSlider.addEventListener('change', () => this.handlePriceRangeDoubleInput(rangeInput, fromSlider, toSlider));
        } else {
          rangeInput.addEventListener('input', () => this.handleDoubleRangeInput(rangeInput));
        }
      });
    }

    /**
     * Handles selection and deselection of filter checkboxes.
     * @param {Event} event - The change event from a checkbox.
     */
    handleFilterChange(event) {
      const checkbox = event.target;
      const filterBy = checkbox.dataset.filterBy;
      const filterValue = checkbox.dataset.filter;
      // Removed unused variable 'filterLabel'

      if (!filterBy || !filterValue) return;

      if (filterBy === this.sortByFilter) {
        this.activeFilters.sort_by = checkbox.checked ? filterValue : null;
        this.handleCollectionChange();
        return;
      }

      if (!this.activeFilters.filter[filterBy]) {
        this.activeFilters.filter[filterBy] = new Set();
      }

      if (checkbox.checked) {
        this.activeFilters.filter[filterBy].add(filterValue);
      } else {
        this.activeFilters.filter[filterBy].delete(filterValue);
        if (this.activeFilters.filter[filterBy].size === 0) {
          delete this.activeFilters.filter[filterBy];
        }
      }

      // Call fetch immediately for checkbox changes
      this.handleCollectionChange();
    }

    /**
     * Clears all active filters and resets the checkboxes.
     * @returns {void}
     */
    clearFilters() {
      this.activeFilters.filter = {};
      this.tempRangeFilters = {}; // Clear temporary range filters

      this.selectors.filterCheckboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });

      this.updateCheckBoxesActiveState();
      this.handleCollectionChange();
    }

    /**
     * Reads the URL parameters and initializes activeFilters.a
     * Also updates checkboxes based on existing filters.
     */
    syncFiltersFromURL() {
      const urlParams = new URLSearchParams(window.location.search);

      urlParams.forEach((value, key) => {
        if (key === this.sortByFilter || key === this.pageFilter) {
          this.activeFilters[key] = value;
        } else if (key.includes(this.filter)) {
          if (!this.activeFilters.filter[key]) {
            this.activeFilters.filter[key] = new Set();
          }
          this.activeFilters.filter[key].add(value);
        }
      });
      const priceGte = parseInt(urlParams.get(this.filterPriceGte), 10);
      const priceLte = parseInt(urlParams.get(this.filterPriceLte), 10);

      // Process price range filters
      [
        { value: priceGte, key: this.filterPriceGte, prop: 'min' },
        { value: priceLte, key: this.filterPriceLte, prop: 'max' },
      ].forEach(({ value, key, prop }) => {
        if (!isNaN(value)) {
          this.tempRangeFilters[key] = { [prop]: value };
          if (!this.activeFilters.filter[key]) {
            this.activeFilters.filter[key] = new Set();
          }

          this.activeFilters.filter[key].add(value.toString());
        }
      });

      // Apply range filters from URL
      this.applyRangeFilters();
      this.updateCheckBoxesActiveState();
    }

    updateCheckBoxesActiveState() {
      let selectedSortLabel = '';

      this.selectors.filterCheckboxes.forEach((checkbox) => {
        const filterBy = checkbox.dataset.filterBy;
        const filterValue = checkbox.dataset.filter;
        const filterLabel = checkbox.dataset.filterLabel;

        if (filterBy && filterValue) {
          if (filterBy === this.sortByFilter) {
            checkbox.checked = this.activeFilters[filterBy] === filterValue;
            if (checkbox.checked) selectedSortLabel = filterLabel || filterValue;
          } else {
            checkbox.checked = this.activeFilters.filter[filterBy]?.has(filterValue) || false;
          }
        }
      });

      // Update selectPlaceholder based on active sort_by
      if (this.selectors.selectPlaceholder) {
        this.selectors.selectPlaceholder.textContent = selectedSortLabel ? selectedSortLabel : 'Sort';
      }
    }

    /**
     * Public method to update the component from current URL parameters.
     */
    updateFromUrlParams() {
      this.syncFiltersFromURL();
      this.handleCollectionChange();
      this.updateDoubleRangeInputsFromUrl();
    }

    /**
     * Updates the URL with debouncing for filter changes
     * @param {string} url - The URL to update to
     * @param {boolean} [immediate=false] - Whether to update immediately
     */
    updateURL(url, immediate = false) {
      // Clear any existing timeout
      if (this.updateURLTimeout) {
        clearTimeout(this.updateURLTimeout);
      }

      if (immediate) {
        // For immediate updates (like direct navigation), use replaceState
        window.history.replaceState({ path: url }, '', url);
      } else {
        // For filter changes, debounce the update
        this.updateURLTimeout = setTimeout(() => {
          window.history.replaceState({ path: url }, '', url);
        }, 500); // Wait 500ms before updating URL
      }
    }

    /**
     * Fetches and updates the collection content dynamically.
     */
    async handleCollectionChange() {
      const url = this.generateUrl();
      if (this.isLoadingCollection) return;
      this.isLoadingCollection = true;
      this.setLoadingState();

      try {
        const response = await fetch(url, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) throw new Error(`Failed to fetch: ${response.statusText}`);

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        this.updateURL(url);
        this.updateContent(doc);
      } catch (error) {
        console.error('[WLS] Error fetching collection:', error);
      }
      this.isLoadingCollection = false;
      this.clearLoadingState();
    }

    /**
     * Updates the collection content dynamically and reinitializes components.
     * @param {Document} doc - The parsed HTML document.
     */
    updateContent(doc) {
      const elementsToUpdate = [
        { selector: 'contentWrapper', className: this.classes.contentWrapper },
        // { selector: 'filtersNavigationWarpper', className: this.classes.filtersNavigationWarpper },
        { selector: 'contentSections', className: this.classes.contentSections },
        { selector: 'contentWrapperCollectionList', className: this.classes.contentWrapperCollectionList },
      ];

      elementsToUpdate.forEach(({ selector, className }) => {
        if (this.selectors[selector]) {
          const newContent = doc.querySelector(`.${className}`);
          if (newContent) {
            this.selectors[selector].innerHTML = newContent.innerHTML;
          }
        }
      });

      // Update selectors after DOM insertion
      this.selectors = this.getSelectors();
      this.bindEvents();

      const hasCollectionSections = this.hasAttribute(this.classes.dataCollectionSections);

      if (hasCollectionSections) {
        this.sortAndAssignProductsToCollections();
      } else {
        this.sortAndUpdateSingleSection();
      }
      this.dispatchUpdateCollectionEvent();
      this.updateCheckBoxesActiveState();
      this.updateDoubleRangeInputsFromUrl();
      this.applyRangeFilters(); // Apply range filters after content update
    }

    /**
     * @returns {void}
     * @description This method iterates through each collection block and checks if the product list is empty. If it is, it adds a hidden class to the product list.
     */
    checkAndHideEmptyProductList() {
      this.selectors.WLSCollectionSections.forEach((block) => {
        const feedBackMessage = block.querySelector(`.${this.classes.sectionCollectionFallbackMessage}`);
        const productListWrapper = block.querySelector(`.${this.classes.productListWrapper}`);
        const productList = block.querySelector(`.${this.classes.collectionBlockProductList}`);
        if (productList && productListWrapper && feedBackMessage && productList.children.length === 0) {
          productListWrapper.classList.add(this.classes.hidden);
          feedBackMessage.classList.remove(this.classes.hidden);
          block.classList.add(this.classes.empty);
        } else {
          productListWrapper.classList.remove(this.classes.hidden);
          feedBackMessage.classList.add(this.classes.hidden);
          block.classList.remove(this.classes.empty);
        }
      });
    }

    /**
     * Sorts products and assigns them to their respective collections.
     * @returns {void}
     * @description This method sorts the products based on the selected sort option and assigns them to their respective collection blocks.
     */
    sortAndAssignProductsToCollections() {
      this.setLoadingState(); // Add loading class
      let productsArray = Array.from(this.selectors.collectionProducts);
      let collectionSectionsItemsCounter = 0;

      // Apply custom sorting logic first (if required)
      if (this.customSortByValues.includes(this.activeFilters.sort_by)) {
        productsArray = this.getSortedProducts(productsArray, this.activeFilters.sort_by);
      }

      // Then assign sorted products to collections
      this.selectors.collectionBlocks.forEach((block) => {
        const collectionID = block.dataset.collectionId;
        const productListContainer = block.querySelector(`.${this.classes.collectionBlockProductList}`);
        if (!collectionID || !productListContainer) return;

        productListContainer.innerHTML = '';

        const matchingProducts = productsArray.filter((product) => {
          const collectionIds = product.dataset.collectionIds?.split(',') || [];
          return collectionIds.includes(collectionID);
        });

        matchingProducts.forEach((product) => {
          productListContainer.appendChild(product);
        });
        collectionSectionsItemsCounter += matchingProducts.length;
      });

      this.selectors.filtersNavigationItemsCounter.innerHTML = collectionSectionsItemsCounter;
      this.checkAndHideEmptyProductList();
      this.clearLoadingState();
    }

    /**
     * Sorts products and re-renders them into the single content wrapper section.
     * Used when there are no collection blocks.
     */
    sortAndUpdateSingleSection() {
      if (!this.customSortByValues.includes(this.activeFilters.sort_by)) return;
      this.setLoadingState();

      const contentWrapper = this.selectors.contentWrapperCollectionList;
      const existingElements = Array.from(contentWrapper.children);
      // Separate product cards and promo cards
      const productCards = existingElements.filter((element) => !element.classList.contains('wls-promo-card'));
      const promoCards = existingElements.filter((element) => element.classList.contains('wls-promo-card'));

      // Sort product cards based on the active filter
      let sortedProducts = productCards;
      if (this.customSortByValues.includes(this.activeFilters.sort_by)) {
        sortedProducts = this.getSortedProducts(productCards, this.activeFilters.sort_by);
      }

      // Create a map array to track the layout (p = product, c = promo card)
      const layoutMap = [];

      // First, loop through the existing elements and fill the layoutMap with "p" or "c" based on the element type
      existingElements.forEach((element) => {
        if (element.classList.contains('wls-promo-card')) {
          layoutMap.push('c'); // "c" for promo card
        } else {
          layoutMap.push('p'); // "p" for product card
        }
      });

      // Now create a new array where we will insert promo cards at the correct positions
      let productIndex = 0;
      let promoIndex = 0;
      let newGridContent = [];

      layoutMap.forEach((item) => {
        if (item === 'c' && promoCards[promoIndex]) {
          // Insert promo card
          newGridContent.push(promoCards[promoIndex]);
          promoIndex++;
        } else if (item === 'p' && sortedProducts[productIndex]) {
          // Insert sorted product card
          newGridContent.push(sortedProducts[productIndex]);
          productIndex++;
        }
      });

      // Clear current content (products and promo cards)
      contentWrapper.innerHTML = '';

      // Append the new sorted content (products and promo cards in their respective positions)
      newGridContent.forEach((item) => {
        if (item instanceof Node) {
          contentWrapper.appendChild(item);
        } else {
          console.error('Invalid DOM node:', item); // Debug invalid elements
        }
      });

      this.clearLoadingState();
    }

    /**
     * Sorts products based on the selected sort option.
     * @param {Array} productsArray - The array of product elements to be sorted.
     * @param {string} sortValue - The selected sort option.
     * @returns {Array} - The sorted array of product elements.
     * @description This method sorts the products based on the selected sort option. It first filters the products with strength data attributes and sorts them based on the selected sort option. Then, it returns the sorted array of product elements.
     */
    getSortedProducts(productsArray, sortValue) {
      const productsWithStrength = productsArray.filter((product) => product.dataset.strength);
      const productsWithoutStrength = productsArray.filter((product) => !product.dataset.strength);

      productsWithStrength.sort((a, b) => {
        const strengthA = parseInt(a.dataset.strength, 10);
        const strengthB = parseInt(b.dataset.strength, 10);
        return sortValue === 'strength-ascending' ? strengthA - strengthB : strengthB - strengthA;
      });

      return [...productsWithStrength, ...productsWithoutStrength];
    }
    /**
     * Generate the browser URL with selected filters.
     */
    generateUrl(getOnlyParams = false) {
      const urlParams = new URLSearchParams();
      if (this.activeFilters.sort_by) {
        urlParams.set(this.sortByFilter, this.activeFilters.sort_by);
      }

      Object.keys(this.activeFilters.filter).forEach((filterBy) => {
        this.activeFilters.filter[filterBy].forEach((value) => {
          urlParams.append(filterBy, value);
        });
      });
      if (getOnlyParams) {
        return urlParams.toString();
      } else {
        return `${window.location.pathname}?${urlParams.toString()}`;
      }
    }

    dispatchUpdateCollectionEvent() {
      this.dispatchCustomEvent('update-collection-layout');
      this.dispatchCustomEvent('update-collection-filters');
    }

    /**
     * Dispatches a custom event with the given name.
     * @param {string} eventName - The name of the event to dispatch.
     */
    dispatchCustomEvent(eventName) {
      const event = new CustomEvent(eventName, { bubbles: true, composed: true });
      this.dispatchEvent(event);
    }

    /**
     * Clears filters from activeFilters that are not present in the URL.
     * @returns {void}
     */
    clearFiltersNotInUrl() {
      const urlParams = new URLSearchParams(window.location.search);

      // Clear sort_by if not in URL
      if (!urlParams.has(this.sortByFilter)) {
        this.activeFilters.sort_by = null;
      }

      // Handle price filters first
      const priceGte = urlParams.get(this.filterPriceGte);
      const priceLte = urlParams.get(this.filterPriceLte);

      // Initialize price filters if they don't exist
      if (!this.activeFilters.filter[this.filterPriceGte]) {
        this.activeFilters.filter[this.filterPriceGte] = new Set();
      }
      if (!this.activeFilters.filter[this.filterPriceLte]) {
        this.activeFilters.filter[this.filterPriceLte] = new Set();
      }

      // Update price filters from URL
      this.activeFilters.filter[this.filterPriceGte].clear();
      this.activeFilters.filter[this.filterPriceLte].clear();

      if (priceGte) {
        this.activeFilters.filter[this.filterPriceGte].add(priceGte);
        this.tempRangeFilters[this.filterPriceGte] = {
          min: parseInt(priceGte, 10),
        };
      }
      if (priceLte) {
        this.activeFilters.filter[this.filterPriceLte].add(priceLte);
        this.tempRangeFilters[this.filterPriceLte] = {
          max: parseInt(priceLte, 10),
        };
      }

      // Clear other filters not in URL
      Object.keys(this.activeFilters.filter).forEach((filterBy) => {
        // Skip price filters as they're handled above
        if (filterBy !== this.filterPriceGte && filterBy !== this.filterPriceLte) {
          const filterValues = Array.from(this.activeFilters.filter[filterBy]);
          filterValues.forEach((value) => {
            if (!urlParams.getAll(filterBy).includes(value)) {
              this.activeFilters.filter[filterBy].delete(value);
            }
          });

          // Remove empty non-price filters
          if (this.activeFilters.filter[filterBy].size === 0) {
            delete this.activeFilters.filter[filterBy];
          }
        }
      });

      // Clean up empty price filters
      if (this.activeFilters.filter[this.filterPriceGte]?.size === 0) {
        delete this.activeFilters.filter[this.filterPriceGte];
        delete this.tempRangeFilters[this.filterPriceGte];
      }
      if (this.activeFilters.filter[this.filterPriceLte]?.size === 0) {
        delete this.activeFilters.filter[this.filterPriceLte];
        delete this.tempRangeFilters[this.filterPriceLte];
      }

      this.updateCheckBoxesActiveState();
      this.updateDoubleRangeInputsFromUrl();
      this.applyRangeFilters(); // Apply range filters after clearing
    }

    /**
     * Handles the double range input for filtering.
     * @param {HTMLElement} rangeInput - The double range input element.
     * @description This method updates the temporary range filters based on the selected range input values.
     * @returns {void}
     */
    handleDoubleRangeInput(rangeInput) {
      const filterBy = rangeInput.dataset.filterBy;
      const min = parseInt(rangeInput.dataset.min, 10);
      const max = parseInt(rangeInput.dataset.max, 10);

      if (!filterBy) return;

      // Store the range values temporarily
      this.tempRangeFilters[filterBy] = { min, max };

      this.updateCheckBoxesActiveState();

      // Debounce the fetch call for range inputs
      this.debouncedFetch();
    }

    /**
     * Handles the double range input for price filtering.
     * @param {HTMLElement} fromSlider - The "from" slider element.
     * @param {HTMLElement} toSlider - The "to" slider element.
     * @description This method updates the temporary range filters based on the selected range input values.
     * @returns {void}
     */
    handlePriceRangeDoubleInput(rangeInput, fromSlider, toSlider) {
      const min = parseInt(rangeInput.dataset.min, 10);
      const max = parseInt(rangeInput.dataset.max, 10);
      const defaultMin = parseInt(fromSlider.min, 10);
      const defaultMax = parseInt(toSlider.max, 10);
      this.tempRangeFilters[this.filterPriceGte] = { min, defaultMin };
      this.tempRangeFilters[this.filterPriceLte] = { max, defaultMax };

      // Debounce the fetch call for price range inputs
      this.debouncedFetch();
    }

    /**
     * Debounced fetch method for range inputs
     * @returns {void}
     */
    debouncedFetch() {
      // Clear any existing timeout
      if (this.rangeDebounceTimeout) {
        clearTimeout(this.rangeDebounceTimeout);
      }

      // Set a new timeout for 500ms
      this.rangeDebounceTimeout = setTimeout(() => {
        this.applyRangeFilters();
        this.handleCollectionChange();
      }, 500);
    }

    /**
     * Applies range filters to activeFilters before fetching
     * @returns {void}
     */
    applyRangeFilters() {
      // Update activeFilters with temporary range filters
      Object.keys(this.tempRangeFilters).forEach((filterBy) => {
        const { min, max } = this.tempRangeFilters[filterBy];
        this.activeFilters.filter[filterBy] = new Set();

        // Find all checkboxes matching the filterBy
        this.selectors.filterCheckboxes.forEach((checkbox) => {
          if (checkbox.dataset.filterBy === filterBy) {
            const value = parseInt(checkbox.dataset.filterLabel, 10);
            if (value >= min && value <= max) {
              this.activeFilters.filter[filterBy].add(checkbox.dataset.filter);
            }
          }
        });

        // Remove the filter if no values are in range
        if (this.activeFilters.filter[filterBy].size === 0) {
          delete this.activeFilters.filter[filterBy];
        }
      });

      // Handle the case where all filterStrength values are selected
      if (this.tempRangeFilters[this.filterStrength]) {
        const { min, max } = this.tempRangeFilters[this.filterStrength];
        const allFilterValues = Array.from(this.selectors.filterCheckboxes)
          .filter((checkbox) => checkbox.dataset.filterBy === this.filterStrength)
          .map((checkbox) => parseInt(checkbox.dataset.filterLabel, 10))
          .filter((value) => !isNaN(value));

        const allValuesInRange = allFilterValues.every((value) => value >= min && value <= max);

        if (allValuesInRange) {
          delete this.activeFilters.filter[this.filterStrength];
        }
      }

      // Handle price range filters
      [
        { key: this.filterPriceGte, prop: 'min', defaultProp: 'defaultMin' },
        { key: this.filterPriceLte, prop: 'max', defaultProp: 'defaultMax' },
      ].forEach(({ key, prop, defaultProp }) => {
        const range = this.tempRangeFilters[key];
        if (range) {
          const value = range[prop];
          const defaultValue = range[defaultProp];

          if (value === defaultValue) {
            delete this.activeFilters.filter[key];
          } else {
            this.activeFilters.filter[key] = new Set([value]);
          }
        }
      });
    }

    /**
     * Updates the double range inputs based on URL parameters.
     */
    updateDoubleRangeInputsFromUrl() {
      this.selectors.doulbeRangeInputSelectors.forEach((rangeInput) => {
        const filterBy = rangeInput.dataset.filterBy;
        const fromSlider = rangeInput.querySelector(`.${this.classes.fromSlider}`);
        const toSlider = rangeInput.querySelector(`.${this.classes.toSlider}`);
        const toPlaceholder = rangeInput.querySelector(`.${this.classes.toPlaceholder}`);
        const fromPlaceholder = rangeInput.querySelector(`.${this.classes.fromPlaceholder}`);
        const defaultMin = parseInt(fromSlider.min, 10);
        const defaultMax = parseInt(toSlider.max, 10);
        if (!filterBy) return;

        if (filterBy === this.filterStrength) {
          const filterKeys = rangeInput.dataset.filterKeys?.split(',').filter(Boolean) || [];
          const filterValues =
            rangeInput.dataset.filterValues
              ?.split(',')
              .map((v) => parseInt(v, 10))
              .filter(Boolean) || [];
          const selectedKeys = Array.from(this.activeFilters.filter[filterBy] || []);
          const selectedValues = selectedKeys
            .map((key) => {
              const index = filterKeys.indexOf(key);
              return index !== -1 ? filterValues[index] : null;
            })
            .filter((value) => value !== null);

          // Reset to default state
          if (selectedValues.length === 0) {
            rangeInput.dataset.min = defaultMin;
            rangeInput.dataset.max = defaultMax;
            fromPlaceholder.textContent = defaultMin;
            toPlaceholder.textContent = defaultMax;
            if (fromSlider) {
              fromSlider.value = defaultMin;
            }
            if (toSlider) {
              toSlider.value = defaultMax;
            }
            return;
          }

          const min = Math.min(...selectedValues);
          const max = Math.max(...selectedValues);
          rangeInput.dataset.min = min;
          rangeInput.dataset.max = max;
          fromPlaceholder.textContent = min;
          toPlaceholder.textContent = max;
          if (fromSlider) {
            fromSlider.value = min;
          }
          if (toSlider) {
            toSlider.value = max;
          }
        } else if (filterBy === this.filterPrice) {
          const min =
            this.tempRangeFilters[this.filterPriceGte]?.min ||
            parseInt([...(this.activeFilters.filter[this.filterPriceGte] || [])][0], 10) ||
            defaultMin;

          const max =
            this.tempRangeFilters[this.filterPriceLte]?.max ||
            parseInt([...(this.activeFilters.filter[this.filterPriceLte] || [])][0], 10) ||
            defaultMax;
          rangeInput.dataset.min = min;
          rangeInput.dataset.max = max;
          fromSlider.value = min;
          toSlider.value = max;
          fromPlaceholder.textContent = min;
          toPlaceholder.textContent = max;
        }
      });
      this.dispatchCustomEvent('update-double-range-input');
    }

    /**
     * Adds the loading class to the element.
     */
    setLoadingState() {
      this.classList.add(this.classes.loading);
    }

    /**
     * Removes the loading class from the element.
     */
    clearLoadingState() {
      this.classList.remove(this.classes.loading);
    }
  }

  window.customElements.define('wls-collection', WLSCollection);
}
